import { render } from "./bby.vue?vue&type=template&id=29605da5&scoped=true"
import script from "./bby.vue?vue&type=script&lang=js"
export * from "./bby.vue?vue&type=script&lang=js"

import "./bby.vue?vue&type=style&index=0&id=29605da5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29605da5"]])

export default __exports__